import * as React from 'react';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentDiagnosisFailureMessage = ({
  failureReason
}) => {
  if (getIsInternal()) {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      type: "badRequest",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.diagnoseFailure.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.diagnoseFailure.description.${failureReason}`
      })
    });
  }
  const supportedExternalKey = `flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.diagnoseFailure.descriptionExternal.${failureReason}`;
  if (isValidI18nKey(supportedExternalKey)) {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      type: "badRequest",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.diagnoseFailure.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: supportedExternalKey
      })
    });
  }
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "badRequest",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.diagnoseFailure.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.diagnoseFailure.descriptionExternal.default"
    })
  });
};
export default EnrollmentDiagnosisFailureMessage;